var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJavascript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Type=Default",
    clipPath: "url(#clip0_335_250)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H512V512H0V0Z",
    fill: "#F7DF1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.624 427.865L173.806 404.153C181.365 417.555 188.241 428.894 204.735 428.894C220.545 428.894 230.513 422.71 230.513 398.654V235.058H278.628V399.334C278.628 449.169 249.416 471.852 206.797 471.852C168.307 471.852 145.964 451.917 134.623 427.861",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.762 422.709L343.939 400.026C354.252 416.868 367.656 429.24 391.369 429.24C411.305 429.24 424.018 419.272 424.018 405.524C424.018 389.027 410.959 383.184 388.962 373.564L376.937 368.405C342.222 353.63 319.194 335.071 319.194 295.89C319.194 259.803 346.689 232.307 389.651 232.307C420.24 232.307 442.235 242.962 458.043 270.801L420.581 294.858C412.332 280.08 403.399 274.239 389.652 274.239C375.561 274.239 366.624 283.174 366.624 294.858C366.624 309.293 375.561 315.137 396.18 324.073L408.208 329.228C449.107 346.757 472.135 364.627 472.135 404.837C472.135 448.144 438.11 471.856 392.401 471.856C347.722 471.856 318.851 450.549 304.763 422.709",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_335_250"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.cbe4adab1f0dad33bf000c64d054bd2c.svg";
export { ForwardRef as ReactComponent };